import PublicMainLayout from './PublicMainLayout'

export default PublicMainLayout
